import { API, axiosInstance } from "lib";

export const getMateriallist = (data = {}) => {
  return axiosInstance
    .post(API.GET_MATERIAL_LIST, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const changeMaterialStatus = (data = {}) => {
  return axiosInstance
    .post(API.CHANGE_MATERIAL_STATUS, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const addMaterialType = (data = {}) => {
  return axiosInstance
    .post(API.ADD_MATERIAL_TYPE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const deleteMaterialType = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_MATERIAL_TYPE, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};

export const deleteUserData = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_USER_DATA, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
    });
};
